import React from 'react';
import logo from '../../../assets/images/logo192.png';
// Substratum has been discontinued. Sign in is disabled and every auth route
// now renders the discontinuation notice instead of the login flow.
var AuthRoutes = function () {
    return (React.createElement("div", { className: 'bg-primary text-primary flex h-screen w-screen flex-col items-center justify-center pt-[var(--app-top-banner-offset)]' },
        React.createElement(RenderDiscontinued, null)));
};
var RenderDiscontinued = function () {
    return (React.createElement("div", { className: 'auth-form m-4 flex max-w-md flex-col items-center gap-3 text-center' },
        React.createElement("img", { className: 'mb-2 w-20', alt: 'substratum logo', src: logo }),
        React.createElement("h2", { className: 'mb-1 font-display' }, "Substratum has been discontinued"),
        React.createElement("p", { className: 'text-secondary' }, "Substratum is no longer available and sign in has been disabled. Thank you for being part of the community."),
        React.createElement("p", { className: 'text-secondary mt-2' },
            "Need help migrating your data out of the platform? Reach out at",
            ' ',
            React.createElement("a", { className: 'underline underline-offset-4', href: 'mailto:support@cmdshift.studio' }, "support@cmdshift.studio"),
            ".")));
};
export default AuthRoutes;
